export const toneClassMap = {
  neutralBadge: "border border-border bg-muted/40 text-muted-foreground",
  successBadge: "border border-success/30 bg-success/10 text-success",
  warningBadge: "border border-warning/30 bg-warning/10 text-warning",
  dangerBadge: "border border-destructive/30 bg-destructive/10 text-destructive",
  infoBadge: "border border-info/30 bg-info/10 text-info",
  warningPanel: "border border-warning/30 bg-warning/10 text-warning",
  successOutlineButton: "border-success/40 text-success hover:bg-success/10",
  successOutlineButtonActive: "border-success/40 bg-success/10 text-success",
  dangerOutlineButton: "border-destructive/40 text-destructive hover:bg-destructive/10",
  dangerOutlineButtonActive: "border-destructive/40 bg-destructive/10 text-destructive",
};

export function getComparisonToneClass(change) {
  if (!change || change.percent == null) return toneClassMap.neutralBadge;
  if (change.direction === "up") return toneClassMap.successBadge;
  if (change.direction === "down") return toneClassMap.dangerBadge;
  return toneClassMap.neutralBadge;
}
